import Home from './home'
import RecycleRecord from './recycleRecord'
export default {
  Home,
  RecycleRecord
}
